import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Icon from "../../Icons/general/Icon";
import { login } from "../../services/auth";
import Toasts from "../../components/toast";

function Login() {
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [validar, setValidar] = useState(false);
  const [habilita, setHabilita] = useState(false);
  const [opciones, setOpciones] = useState([]);
  
  const navigate = useNavigate();
  const handleLogin = async () => 
    {
        setValidar(true);
        setHabilita(true);
        setShowToast(false);

        if (usuario !== "" && password !== "") 
          {
             let response = await login(usuario, password);
             
             if (response.status === 200) 
              {
                 const { data } = response;
                 if (!data.error) 
                  {
                    localStorage.setItem("1dTkApp", data.token);
                    navigate("/home");
                  } 
                 else 
                  {
                     const Mensaje = data.message;
                     const opc = { type: "Danger", message: Mensaje, active: true };
                     setOpciones(opc);
                     setShowToast(true);
                  }
                  
              } 
             else 
             {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
             }
          }
    setHabilita(false);
  };

   // min-h-[18rem] 

  return (
    <div className=" flex h-screen items-center justify-center bg-[url('/public/pattern.svg')]  bg-repeat">
      <div>
        <div className=" max-w-sm lg:max-w-lg min-h-[12rem] w-[20rem]  2xl:min-h-[18rem] 2xl:w-[25rem] rounded overflow-hidden shadow-lg border border-default">
          <div className="max-w h-[2.3rem] 2xl:h-[2.8rem] flex items-center px-4  bg-default text-white text-[0.71rem] 2xl:text-base">
            Iniciar Sesión
          </div>
          <div className="bg-white max-w max-h py-3 2xl:py-6 px-4">
            <div className="w-full">
              <label
                htmlFor="website-admin"
                className="block text-[0.71rem] 2xl:text-sm font-medium text-gray-900 dark:text-white"
              >
                Usuario
              </label>
              <div className="flex">
                <span
                  className={`inline-flex items-center px-3 text-sm bg-default rounded-none rounded-l-lg border-default ${
                    validar && usuario === "" ? `border-red-500 bg-red-500` : ""
                  }`}
                >
                  <Icon
                    svg="user"
                    className={`w-4 h-4 2xl:w-5 2xl:h-5 fill-current text-white ${
                      validar && usuario === "" ? `border-red-500 fill-red` : ""
                    }`}
                    title="user"
                  />
                </span>
                <input
                  type="text"
                  id="website-admin"
                  onChange={(e) => setUsuario(e.target.value)}
                  value={usuario}
                  className={`notext peer h-[2.0rem] 2xl:h-[2.5rem] min-w-0 w-full p-2.5 bg-gray-50 placeholder:italic rounded-none border border-gray-300 text-gray-900 focus:ring-0 focus:bg-white focus:outline-none focus:border-default block flex-1  text-[0.71rem] md:text-sm ${
                    validar && usuario === ""
                      ? `border-red-500 focus:border-red-500 focus:red-500`
                      : ""
                  }`}
                  placeholder="Ingresa el usuario"
                  autoComplete="off"
                  required
                ></input>
              </div>
              {validar && usuario === "" ? (
                <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                  * Campo Obligatorio.
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="w-full">
              <label
                htmlFor="lbpassword"
                className="block pt-4 text-[0.71rem] 2xl:text-sm font-medium text-gray-900"
              >
                Contraseña
              </label>
              <div className="flex">
                <span
                  className={`inline-flex items-center px-3 text-sm bg-default rounded-none rounded-l-lg border-default ${
                    validar && password === ""
                      ? `border-red-500 bg-red-500`
                      : ""
                  }`}
                >
                  <Icon
                    svg="lock"
                    className={`w-4 h-4 2xl:w-5 2xl:h-5 fill-current text-white ${
                      validar && password === ""
                        ? `border-red-500 fill-red`
                        : ""
                    }`}
                    title="lock"
                  />
                </span>
                <input
                  type="password"
                  id="password"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  className={`notext placeholder:italic h-[2.0rem] 2xl:h-[2.5rem] min-w-0 w-full p-2.5 rounded-none bg-gray-50 border border-gray-300 text-gray-900 focus:ring-0 focus:bg-white focus:outline-none focus:border-default block flex-1  text-[0.71rem] md:text-sm ${
                    validar && password === ""
                      ? `border-red-500 focus:border-red-500 focus:red-500`
                      : ""
                  }`}
                  placeholder="Ingresa su contraseña"
                  autoComplete="off"
                ></input>
              </div>
              {validar && password === "" ? (
                <p className="text-red-500 text-[0.6rem] font-medium italic ">
                  * Campo Obligatorio.
                </p>
              ) : (
                ""
              )}
            </div>
            <button
              className="text-default mt-[1.2rem] bg-white md:font-medium rounded-lg w-full h-[2.0rem] 2xl:h-[2.5rem] border border-default hover:bg-default hover:text-white focus:border-default disabled:bg-disabled disabled:border-disabled"
              onClick={handleLogin}
              disabled={habilita}
            >
              Ingresar
            </button>
          </div>
        </div>
        <div className="mt-4 md:mt-6 w-full ">
          <div className="inline-flex flex justify-center w-full space-x-4">
            <Link
              to="screen"
              className="w-12 h-12 rounded-full border border-default flex justify-center items-center  opacity-80 hover:opacity-100"
            >
              <Icon
                svg="tv"
                className="w-8 h-8 fill-default opacity-80 hover:opacity-100"
                title="tv"
              />
            </Link>
            <Link
              to="dispenser"
              className="w-12 h-12 rounded-full border border-default flex justify-center items-center opacity-80 hover:opacity-100"
            >
              <Icon
                svg="list"
                className="w-8 h-8 fill-default opacity-80 hover:opacity-100"
                title="list"
              />
            </Link>
          </div>
          <p className="text-[0.71rem] 2xl:text-sm mt-4 2xl:mt-6">
            © Copyright 2023 Dkd Ingenierías - Derechos reservados.
          </p>
        </div>
      </div>
      {showToast ? (
            <Toasts
              type={opciones.type}
              message={opciones.message}
              active={opciones.active}
            ></Toasts>
          ) : (
            ""
          )}
    </div>
  );
}
export default Login;
